export const SET_AUTH = 'auth/SET_AUTH';
export const SET_PROFILE = 'auth/SET_PROFILE';
export const LOG_OUT = 'auth/LOG_OUT';
